import React from 'react';
import { IMask } from 'react-imask';

import { SubTitle } from './styles';
import { masks } from '@src/common/masks';
import useTranslate from '@src/i18n/useTranslate';
import { BRAZIL_PHONE_DDI } from '@src/features/order';
import usePhoneVerification from '@src/hooks/usePhoneVerification';

interface ParagraphProps extends Omit<React.HTMLAttributes<HTMLParagraphElement>, 'children'> {
  label?: string;
}

const Description = ({ label, ...rest }: ParagraphProps) => {
  const { i18n } = useTranslate();
  const { buyer } = usePhoneVerification();

  const getMaskedPhone = (phone?: string | null) => {
    if (!phone) {
      return '';
    }

    const phoneMasker = IMask.createMask({
      mask: masks['brazilian_phone'],
    });

    if (phone.startsWith(BRAZIL_PHONE_DDI)) {
      return phoneMasker.resolve(phone);
    }

    return phone;
  };

  return (
    <SubTitle {...rest}>
      {label ?? i18n('phone_verification_subtitle')}{' '}
      <strong style={{ fontWeight: 700 }}>{getMaskedPhone(buyer?.phone)}</strong>
    </SubTitle>
  );
};

export default Description;
